// extracted by mini-css-extract-plugin
export default {"whack_mole_item_container":"whack-mole-item_whack_mole_item_container__3iDvB","head":"whack-mole-item_head__BCkW3","hole":"whack-mole-item_hole__Ub-f9"};